var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NotificationsPool'),(this.$route.path !== '/login')?_c('MainContent'):_vm._e(),(this.$route.path === '/login')?_c('Login'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }